import { useState, useEffect } from 'react';
import { Card, Button, Alert, Form, Modal, InputGroup } from 'react-bootstrap';
import GetImage from "./GetImage";
import ModalWaiting from "../Components/ModalWaiting";

const GAS_URL = "https://script.google.com/macros/s/AKfycbxV78M9f2XuypgAEfJ3An-chZD1b_FmDONcUuuP9gCCMdY8hwCrGBatowwBVEXxIevS6A/exec";

function AppForm({ params, userID, userName }) {
  const [uuid, setUuid] = useState("");
  const [formUrl, setFormUrl] = useState("");
  const [waitingShow, setWaitingShow] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [emailModalShow, setEmailModalShow] = useState(false);
  const [gmailUser, setGmailUser] = useState("");
  const [isSent, setIsSent] = useState(false);

  // params に応じてタイトルと画像を切り替え
  const title = params === "albumdigital" ? "アルバム再生工房" : "思い出スライド工房";
  const banner = GetImage(params === "albumdigital" ? "AlbumDigital" : "SlideDigital");

  useEffect(() => {
    if (userID && userName && params) {
      fetchInitData();
    }
  }, [userID, userName, params]);

  const fetchInitData = async () => {
    setWaitingShow(true);
    try {
      const response = await fetch(GAS_URL, {
        method: "POST",
        headers: { "Content-Type": "text/plain" },
        body: JSON.stringify({ action: "initLiffApp", userID, userName, params, mode: "new" })
      });
      const result = await response.json();
      if (result.error) {
        setErrorMessage(result.error);
      } else {
        setUuid(result.uuid);
        setFormUrl(result.formUrl);
      }
    } catch (error) {
      console.error("GAS Fetch Error:", error);
      setErrorMessage("サーバーとの通信に失敗しました。");
    } finally { 
      setWaitingShow(false); 
    }
  };

  const handleEmailModalClose = () => {
    setEmailModalShow(false);
    setGmailUser("");
    setTimeout(() => setIsSent(false), 300);
  };

  const sendPcMail = async () => {
    if (!gmailUser || !uuid) return;
    const fullGmail = gmailUser + "@gmail.com";
    setWaitingShow(true);
    
    try {
      const payload = { action: "sendProjectFormInformation", uuid, userName, gmail: fullGmail, params };
      const response = await fetch(GAS_URL, {
        method: "POST",
        headers: { "Content-Type": "text/plain" },
        body: JSON.stringify(payload)
      });
      const result = await response.json();
      if (result.success) {
        setIsSent(true);
      } else {
        alert("メール送信に失敗しました。");
      }
    } catch (err) {
      console.error("Mail Send Error:", err);
      alert("通信エラーが発生しました。");
    } finally {
      setWaitingShow(false);
    }
  };

  return (
    <>
      <style jsx>{`
        .container-wrapper { display: flex; flex-direction: column; height: 100vh; background: #f8f9fa; }
        .content-area { flex-grow: 1; padding: 20px; overflow-y: auto; display: flex; justify-content: center; }
        .maincard { width: 100%; max-width: 500px; border: none; }
        .card-title-custom { font-size: 1.25rem; font-weight: bold; color: #1a73e8; text-align: center; padding: 10px 0; }
        .w-80 { width: 80%; }
        .action-label { font-weight: bold; margin-bottom: 0.5rem; color: #495057; }
        .sent-msg { font-weight: bold; color: #28a745; text-align: center; padding: 20px 0; }
        .footer-area { background: #ffffff; padding: 15px; display: flex; justify-content: center; border-top: 1px solid #ddd; }
      `}</style>

      <div className="container-wrapper">
        <div className="content-area">
          {!waitingShow && !errorMessage && (
            <Card className="maincard shadow-sm">
              {banner && <Card.Img variant="top" src={banner} />}
              <Card.Body>
                <Card.Title className="card-title-custom mb-3">{title}</Card.Title>

                <div className="action-label">【PCで操作したい方】</div>
                <Alert variant="secondary" className="text-center">
                  <div className="d-flex justify-content-center mt-2">
                    <Button variant="outline-dark" className="w-80 fw-bold" onClick={() => setEmailModalShow(true)}>
                      パソコンに案内を送る
                    </Button>
                  </div>
                </Alert>

                <div className="action-label">サービスのお申し込み</div>
                <Alert variant="info" className="text-center">
                  <div className="d-flex justify-content-center mt-2">
                    <Button variant="primary" className="w-80 fw-bold shadow-sm" onClick={() => formUrl && window.open(formUrl, '_blank')}>
                      スマホで申し込み
                    </Button>
                  </div>
                </Alert>
              </Card.Body>
            </Card>
          )}

          {!waitingShow && errorMessage && (
            <div style={{ maxWidth: '500px', width: '100%', marginTop: '20px' }}>
              <Alert variant="danger" className="text-center shadow-sm">
                <h5 className="fw-bold mb-3">お知らせ</h5>
                <div style={{ whiteSpace: 'pre-wrap' }}>{errorMessage}</div>
              </Alert>
            </div>
          )}
        </div>

        <div className="footer-area">
          <Button variant="outline-secondary" className="px-4" onClick={() => window.close()}>
            閉じる
          </Button>
        </div>
      </div>

      <Modal show={emailModalShow} onHide={handleEmailModalClose} centered>
        {/* モーダルの中身は既存の通り */}
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">{isSent ? "送信完了" : "メール送信"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!isSent ? (
            <>
              <Form.Label className="small fw-bold">Gmailユーザー名を入力してください</Form.Label>
              <InputGroup className="mb-3">
                <Form.Control placeholder="example" value={gmailUser} onChange={(e) => setGmailUser(e.target.value)} />
                <InputGroup.Text>@gmail.com</InputGroup.Text>
              </InputGroup>
            </>
          ) : (
            <div className="sent-msg">パソコン宛に案内メールを送信しました。</div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {!isSent ? (
            <>
              <Button variant="primary" onClick={sendPcMail} disabled={!gmailUser}>送信</Button>
              <Button variant="secondary" onClick={handleEmailModalClose}>閉じる</Button>
            </>
          ) : (
            <Button variant="success" onClick={handleEmailModalClose}>確認しました</Button>
          )}
        </Modal.Footer>
      </Modal>

      <ModalWaiting show={waitingShow} />
    </>
  );
}

export default AppForm;
